<template>
    <div class="orderList">
        <Header ref="header" :title="title" :titleRight="titleRight" @backPage="onBack"></Header>
        <div class="nav" :class="height">
            <div class="navLi" @click="onActive(0)" :class="{'active': active == 'tab-container0'}">
                <span>未使用</span>
            </div>
            <div class="navLi" @click="onActive(1)" :class="{'active': active == 'tab-container1'}">
                <span>已使用</span>
            </div>
            <!-- <div class="navLi" @click="onActive(2)" :class="{'active': active == 'tab-container2'}">
                <span>已失效</span>
            </div> -->
        </div>
        <div class="page-tab-container">
            <div v-if="orderList.length">
                <van-list
                v-model="loading"
                :finished="finished"
                :finished-text="finishText"
                :immediate-check="false"
                @load="onLoad"
                >
                <div class="items" v-for="item in orderList" @click="onEffect(item)" :key="item.id">
                    <div class="itemLeft f64" :class="{'couponCopy': active !== 'tab-container0'}">
                        <span class="f36">¥</span>{{ item.couponValue }}
                    </div>
                    <div class="itemRight" :class="{'effectImg': active === 'tab-container1', 'effectImg2': active === 'tab-container2'}">
                        <div class="title">
                            <h3 class="f28" :class="{'col666': active !== 'tab-container0', 'col000': active === 'tab-container0'}" v-text="item.couponName"></h3>
                            <p class="f24 col666" :class="{'col999': active !== 'tab-container0'}">
                                <span>满{{ item.reachAmount }}元使用</span>
                            </p>
                        </div>
                        <p class="time col666">
                            <!--<span>指定类目参加</span>-->
                            <span v-if="item.couponJoinType === 1">全场参加</span>
                            <span v-if="item.couponJoinType === 2">指定类目</span>
                            <span v-if="item.couponJoinType === 3">指定商品</span>
                        </p>
                        <div class="time col666" :class="{'col999': active !== 'tab-container0'}" v-if="active !== 'tab-container1'">{{ item.effectiveStartDate | formatDate3 }}-{{ item.effectiveEndDate | formatDate3 }}</div>
                        <div class="time col666" :class="{'col999': active !== 'tab-container0'}" v-else>{{ item.orderTime | formatDate3 }}</div>
                    </div>
                </div>
                </van-list>
            </div>
            <div class="msg" v-else>
                <img src="../../../assets/img/b2b/img_empty_coupons@2x.png" alt="">
                暂无优惠券
            </div>
        </div>
    </div>
</template>
<script>
import Header from '../../common/header'
import { mapActions } from 'vuex'
export default {
    name: 'orderList',
    components: {
        Header
    },
    data () {
        return {
            title: '我的优惠券',
            titleRight: '',
            memberCode: '',
            merchantCode: '',
            pageNumber: 1,
            pageSize: 10,
            finishText: '数据已加载完毕',
            orderStatus: '',
            total: 0,
            active: 'tab-container0',
            detailShowStatus: 1,
            loading: false,
            finished: false,
            orderList: [],
            height: ''
        }
    },
    watch: {
        active (newVal, oldVal) {
            this.orderList = []
            this.pageNumber = 1
            this.loading = false
            this.finished = false
            if (newVal === 'tab-container0') {
                this.detailShowStatus = 1
                this.getEffectData()
            } else if (newVal === 'tab-container1') {
                this.detailShowStatus = 2
                this.getEffectData()
            } else if (newVal === 'tab-container2') {
                this.detailShowStatus = 3
                this.getEffectData()
            }
        }
    },
    methods: {
        ...mapActions(['getEffectList']),
        onActive (num) {
            this.active = 'tab-container' + num
        },
        onBack () {
            this.$router.push({ path: '/b2b/order/index' })
        },
        onEffect (item) {
            this.$router.push({ path: '/b2b/home/effect', query: { code: item.couponCode, detailId: item.couponDetailId, type: 'myEffect' } })
        },
        onLoad () {
            this.pageNumber += 1
            this.getEffectData()
        },
        async getEffectData () {
            await this.getEffectList({
                memberCode: this.memberCode,
                merchantCode: this.merchantCode,
                detailShowStatus: this.detailShowStatus,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize
            }).then((data) => {
                this.orderList = this.orderList.concat(data.records)
                this.loading = false
                if (this.orderList.length >= data.total) {
                    this.finished = true
                }
                if (data.total < this.pageSize) {
                    this.finishText = ''
                } else {
                    this.finishText = '数据已加载完毕'
                }
            })
        }
    },
    mounted () {
        let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.memberCode = userInfo.companyCode
        this.merchantCode = userInfo.belongMerchantCode
        this.getEffectData(1)
    }
}
</script>
<style lang="scss" scoped>
.orderList {
    font-size: 28px;
    background: #f5f5f5;
    .nav {
        position: fixed;
        left: 0;
        right: 0;
        display: flex;
        justify-content: space-around;
        background: #ffffff;
        color: #666666;
        z-index: 99;
        .navLi {
            padding: 24px 0;
            &.active {
                color: #ff7a45;
                border-bottom: 4px solid #ff7a45;
            }
        }
    }
    .page-tab-container {
        margin-top: 108px;
        padding: 0 24px;
        padding-bottom: 44px;
        .items {
            background: #ffffff;
            border-radius: 12px;
            margin-top: 20px;
            height: 192px;
            display: flex;
            justify-content: flex-start;
            h3 {
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
                white-space: normal;
                word-break: break-all;
            }
            .itemLeft {
                width: 224px;
                line-height: 192px;
                text-align: center;
                background: url(../../../assets/img/b2b/coupon.png) no-repeat;
                background-size: 100% 100%;
                font-family: SFUIDisplay-Bold;
                font-weight: bold;
                color: rgba(255, 255, 255, 1);
                &.couponCopy {
                    background: url(../../../assets/img/b2b/couponCopy.png)
                        no-repeat;
                    background-size: 100% 100%;
                }
            }
            .itemRight {
                flex: 1;
                padding: 32px 28px 0;
                .title {
                    height: 80px;
                    p {
                        margin-top: 8px;
                    }
                }
                .time {
                    font-size: 22px;
                    // margin-top: 26px;
                    white-space: nowrap;
                    transform: scale(0.95);
                    transform-origin: 0 0 0;
                }
                &.effectImg {
                    background: url(../../../assets/img/b2b/use.png) no-repeat;
                    background-size: 136px 136px;
                    background-position: 322px;
                }
                &.effectImg2 {
                    background: url(../../../assets/img/b2b/effect.png)
                        no-repeat;
                    background-size: 136px 136px;
                    background-position: 322px;
                }
            }
        }
    }
    .loading {
        color: #999;
        text-align: center;
        padding: 40px;
    }
    .msg {
        width: 250px;
        font-size: 26px;
        color: #c7c7cc;
        margin: 0 auto;
        padding-top: 160px;
        text-align: center;
        img {
            width: 176px;
            height: 176px;
            margin: 0 auto;
            display: block;
        }
    }
}
/deep/ .mint-tab-container-item {
    min-height: 600px;
}
</style>